var getStyles = function getStyles(setPosition, triggerRect, tooltipRect, position) {
  var haventMeasuredTooltipYet = !tooltipRect;
  if (haventMeasuredTooltipYet) {
    return {
      visibility: 'hidden'
    };
  }
  return setPosition(triggerRect, tooltipRect, position);
};
export default getStyles;